// Дефолтный текст лендинга — используется, пока не пришёл ответ от
// /api/content, и как запасной вариант, если бэкенд недоступен. Держим в
// синхроне с backend/app/content_defaults.py (там же дефолты для API).

export const DEFAULT_CONTENT = {
    about: {
        title: "Геокарбон",
        subtitle:
            "Картографический проект оценки геохимического связывания CO₂",
        description:
            "Проект помогает выбирать площадки для климатических проектов, оценивать углеродный баланс предприятий и принимать научно обоснованные решения по управлению минеральными отходами.",
        heroCardTitle: "Как работает связывание CO₂",
        co2Caption: "Устойчивые карбонаты — долгосрочное связывание углерода",
        featuresTitle: "Возможности платформы",
        features: [
            {
                title: "Интерактивная карта",
                description:
                    "Региональная оценка потенциала и расположения объектов.",
            },
            {
                title: "Программный комплекс CDR",
                description:
                    "Аналитика минерального и химического состава отходов.",
            },
            {
                title: "Сценарии до 2100 года",
                description:
                    "Сравнение прогнозных периодов и пространственных изменений.",
            },
        ],
    },
    methodology: {
        heading: "Методика оценки потенциала связывания CO₂",
        subheading:
            "Прозрачная последовательность расчётов — от состава отходов до регионального сценария",
        stepsTitle: "Этапы расчёта",
        steps: [
            {
                title: "Сбор исходных данных",
                description:
                    "Тип отхода, объём, координаты и отрасль предприятия",
            },
            {
                title: "Химический и минеральный состав",
                description:
                    "Определение долей Ca- и Mg-содержащих минералов",
            },
            {
                title: "Расчёт карбонизации",
                description: "Оценка теоретического и достижимого потенциала",
            },
            {
                title: "Пространственная модель",
                description: "Агрегация результатов по регионам и сценариям",
            },
        ],
        formulaTitle: "Расчётный принцип",
        resultLabel: "Результат",
        resultValues: [
            "Срот (тСО2/т) — потенциал карбонизации минералов",
            "Ерот (тСО2/т) — потенциал образования щёлочности",
        ],
        citation:
            "Denisov, S., Trutnev, M., Goryajnov, D., Tsvetkov, S., Kasprzhitskii, A., Bortnikova, S., Lazorenko, G., 2026. Carbon dioxide fixation within chrysotile mining residues from the Ak-Dovurak asbestos mine, Tuva Republic (Southern Siberia): Retrospective and prospective assessment. Int. J. Greenh. Gas Control 155, 104740.",
        citationUrl: "https://doi.org/10.1016/j.ijggc.2026.104740",
        qualityTitle: "Документация и контроль качества",
        qualityCards: [
            {
                title: "Исходные допущения",
                description:
                    "Границы применимости, коэффициенты и версия расчётной модели.",
                linkLabel: "Открыть допущения →",
                targetTab: null,
            },
            {
                title: "Источники данных",
                description:
                    "Реестр наборов данных, даты обновления и ссылки на первоисточники.",
                linkLabel: "Посмотреть источники →",
                targetTab: "data",
            },
            {
                title: "Проверка результата",
                description:
                    "Диапазон неопределённости и контроль полноты входных данных.",
                linkLabel: "Как проверяем →",
                targetTab: null,
            },
        ],
    },
    data: {
        heading: "Данные проекта",
        subheading: "Источники исходных данных, использованных в проекте",
        sourcesTitle: "Наборы данных",
    },
};
